import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, LocalService, PageKey, RequestInitialization, RequestType, Status } from '../../../service/local.service';
import { RequestManagementService } from '../../../service/request-management.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss']
})
export class RequestsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table", "request"];
  source: RequestInitialization; maxBodyHeight = 0; businessId: string = '';
  interactionType: InteractionType = InteractionType.None;;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private requestManagementService: RequestManagementService, public configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.configurationManagementService.ensurePageActions(this.businessId == '0' ? PageKey.Requests : PageKey.RequestsBusiness);
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (!this.source) {
      this.requestManagementService.getRequestInitialization(this.businessId).subscribe(result => {
        this.source = result;
      });
    } else {
      this.source.selected.v3 = this.businessId;
      this.requestManagementService.getRequests(this.source.content.paging, this.source.selected).subscribe(result => {
        this.source.content = result;
      });
    }
  }

  onGetText(index, id) {
    let rtn = '-';
    switch (index) {
      case 1: {
        let item = this.source.statuses.find(x => x.key == id);
        if (item)
          rtn = item.value;
      } break;
      case 2: {
        let item = this.source.requestTypes.find(x => x.key == id);
        if (item)
          rtn = item.value;
      } break;
    }
    return rtn;
  }

  getRequestTypes() {
    let allowedTypes: RequestType[] = [];
    switch (this.interactionType) {
      case InteractionType.Business: {
        allowedTypes = [RequestType.BulkUploadProducts];
      } break;
      case InteractionType.Bill_PnixSoft: {
        allowedTypes = [RequestType.BulkUploadLocations, RequestType.CreateTestBusinesses, RequestType.CreateTestDeliverer, RequestType.CreateTestProducts, RequestType.CreateTestUsers, RequestType.BulkUploadUsers];
      } break;
    }
    return this.source.requestTypes.filter(x => allowedTypes.includes(x.key));
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        this.requestManagementService.retryJob(key).subscribe(result => {
          if (result.status == Status.Success) {
            this.onLoad();
          }
          this.localService.showInformationByStatus(result.status);
        });
      } break;
      case 2: {
        this.router.navigate(['/request-log-details' + this.localService.basicParamsString, key]);
      } break;
    }
  }
}
